import { Component } from '@angular/core';
import { BaseNumericPropertyViewModel } from '../../../view-models/base-type/base-numeric-property-view-model';
import { NewBasePropertyTextBox } from './new-base-property-text-box';
import { BigNumber } from '@nts/std/types';
import { NumericMaskSettings } from '@nts/std/utility';

@Component({
    template: ''
})

export abstract class BaseNumericPropertyTextBox<T = BigNumber|number> extends NewBasePropertyTextBox<T> {
    override propertyViewModel: BaseNumericPropertyViewModel<T>;
    
    protected getMaskSettings(): NumericMaskSettings {
        return BaseNumericPropertyViewModel.getMaskSettings(this.propertyViewModel);
    }
}
